export const GoogleMapApiOptions = {
    libraries: ['places', 'geometry', 'drawing', 'visualization'],
    v: '3.58'
};